module.exports = __webpack_public_path__ + "img/9.7e9b25a5.jpg";